/**
 * podcastCovers — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const podcastCoversPack: ToilePack = {
    slug: 'podcast-covers',
    category: 'podcast',
    name: 'Podcast covers',
    tagline: tagline('covers', 'shows', 'styles'),
    chips: chips('shows', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'truecrime', label: 'Cold File', subject: 'a true-crime show, a manila folder and a pinned map thread'},
        {key: 'comedy', label: 'Two Spoons', subject: 'a comedy chat show, two mismatched spoons mid-argument'},
        {key: 'wellness', label: 'Still Water', subject: 'a wellness show, a calm lake with one ripple ring'},
    ],
    styles: [
        {key: 'type', label: 'Type-forward', style: 'bold type-forward, heavy condensed title', palette: 'high contrast, motif behind', framing: 'square, legible as an app tile'},
        {key: 'icon', label: 'Illustrated icon', style: 'illustrated icon in a circular badge', palette: 'flat color, clean sans-serif', framing: 'square, legible as an app tile'},
        {key: 'duotone', label: 'Photo duotone', style: 'photographic duotone treatment', palette: 'one strong two-tone pair', framing: 'square, legible as an app tile'},
    ],
    directions: ['a history show instead', 'in orange and charcoal', 'the title bigger, less art'],
}
